/** API EquipmentType ↔ UI equipment master fields. */

import {
  buildDocRequirementsPayload,
  defaultDocRequirements,
  defaultFieldRequirements,
  parseDocRequirementsFromApi,
} from '../data/master/equipments';

export function equipmentTypeFromApi(row) {
  if (!row) return null;
  const { docRequirements, customDocs } = parseDocRequirementsFromApi(row);
  return {
    id: row.id,
    equipmentId: row.code ?? `#${row.id}`,
    name: row.name ?? '',
    category: row.category ?? '',
    vehicleClass: row.vehicleClass ?? '',
    description: row.description ?? '',
    active: row.isActive !== false,
    fieldRequirements: {
      ...defaultFieldRequirements(),
      ...(row.fieldRequirements || {}),
    },
    docRequirements,
    customDocs,
    docTypes: Array.isArray(row.docTypes) ? row.docTypes : [],
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function equipmentTypeToApi(ui) {
  if (!ui) return null;
  return {
    name: ui.name,
    category: ui.category || null,
    vehicleClass: ui.vehicleClass || null,
    description: ui.description || null,
    isActive: ui.active !== false,
    fieldRequirements: ui.fieldRequirements || defaultFieldRequirements(),
    docRequirements: buildDocRequirementsPayload(
      ui.docRequirements || defaultDocRequirements(),
      ui.customDocs || [],
    ),
  };
}
